/**
 * Create System Setting context for custom hook
 */
import { createContext } from 'react'

const SkusContext = createContext({
  fetchSkus: () => {},
  fetchSkusAll: () => {},
})

export default SkusContext
